var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.778 3.605 3.005 12.71c0 .235-.002.463-.003.683-.018 3.322-.027 4.956 4.366 7.503L23.181 30v-.063l.647-.373c2.826-1.621 4.239-2.432 4.239-7.47V3.884l-.035.02c-.218-.124-.427-.246-.63-.364-2.815-1.636-4.23-2.459-8.622.065zm-6.931 9.684-.035.019 3.43 1.949-3.395-1.971zm3.893 2.252 3.518 2v4.551-8.545l3.884-2.253v-.023l-7.402 4.27z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaid);
export default __webpack_public_path__ + "static/media/MAID.90ec2708fcd7dfd9a1003661ffe01fd3.svg";
export { ForwardRef as ReactComponent };